import React, { Component } from "react";

class NotFound extends Component {
	render() {
		return (
			<div>
				<div className="text-center" style={{ marginTop: "4rem" }}>
					<i
						className="material-icons text-info"
						style={{ fontSize: "4em" }}
					>
						info
					</i>

					<h1 className="text-info">Not found!</h1>
					<p>We couldn't find what you were looking for. </p>
					<button
						type="button"
						onClick={() => this.props.history.goBack()}
						className="mdl-button mdl-button--raised mdl-js-ripple-effect btn-circle btn-success"
					>
						<i className="material-icons">arrow_back</i> Go Back
					</button>
				</div>
			</div>
		);
	}
}

export default NotFound;
